export const firebaseConfig = {
	apiKey: "AIzaSyDZjS32Jz6XHm56VxxvUyJHmdgEPFBvyU4",
	authDomain: "gloomhaven-item-db-db.firebaseapp.com",
	databaseURL: "https://gloomhaven-item-db-db.firebaseio.com",
	projectId: "gloomhaven-item-db-db",
	storageBucket: "gloomhaven-item-db-db.appspot.com",
	messagingSenderId: "1055959523566",
	appId: "1:1055959523566:web:c9e9dd38591be00ea493ff",
};
